import { useState } from 'react'
import Article from '../types/Article'
import { getArticles } from '../repository/getArticles'
import Storage from '../../../lib/Storage'
import Event from '../types/Event'
import dayjs from '../../../lib/dayjs'

const HIVE_URL = 'https://hive.stackcommerce.com'
const ARTICLE_DURATION = 2

type DateRange = { start: Date; end: Date }

const useCalendar = () => {
  const [loading, setLoading] = useState(false)
  const [events, setEvents] = useState<Event[]>([])

  const parseArticle = ({ attributes }: Article, index: number): Event => {
    const offset = (ARTICLE_DURATION + 0.2) * index
    const publishedAt = dayjs(attributes.published_at)
      .startOf('day')
      .add(offset, 'hours')
    const start = publishedAt.toDate()
    const end = publishedAt.add(ARTICLE_DURATION, 'hours').toDate()
    return {
      start,
      end,
      title: attributes.headline,
      url: `${HIVE_URL}/article/preview?cid=${attributes.salesforce_id}`
    }
  }

  const loadEvents = async (range: DateRange) => {
    setLoading(true)

    const activeRole = Storage().getActiveRole()
    const partnerType = activeRole?.type?.toLowerCase()
    const partnerId = activeRole?.id
    const result = await getArticles({ partnerType, partnerId, ...range })
    const groupedArticles: { [key: string]: Article[] } = {}
    let newEvents: Event[] = []

    result.forEach((article: Article) => {
      const date = dayjs(article.attributes.published_at).format('YYYY-MM-DD')
      if (!groupedArticles[date]) {
        groupedArticles[date] = []
      }
      groupedArticles[date].push(article)
    })

    Object.values(groupedArticles).forEach((articles: Article[]) => {
      newEvents = newEvents.concat(articles.map(parseArticle))
    })

    setEvents(newEvents)
    setLoading(false)
  }

  return { events, loading, loadEvents }
}

export default useCalendar
